import { Action, AnyAction, Store } from 'redux';

class StoreWrapper {
  store: Store;

  init(store: Store) {
    this.store = store;
  }

  getState<T = any>(): T {
    return this.store.getState();
  }

  dispatch<A extends Action = AnyAction>(action: A) {
    return this.store.dispatch(action);
  }
}

const store = new StoreWrapper();

export { store };
